import { v4 } from "uuid";
import moment from "moment";
import {
  ExtraApplyTo,
  ExtraLockType,
  ExtraRateType,
  ExtraRestrictionUse,
  ExtraType,
  ExtraUse,
  GuestType,
} from "../types";
import { RangeDateType } from "../components/OpenBooking";
import { defaultExtraCategoryFormFields } from "../../extrasCategories/presentation/mappers/extra-category-form.mapper";

const defaultRangeDateWindow: RangeDateType = {
  startDate: moment().toISOString(),
  endDate: moment().add(10, "y").toISOString(),
};

export const defaultData = {
  id: v4(),
  ticker: "",
  active: true,
  visible: false,
  inventoryLinesList: [],
  chainInventoryLinesList: [],
  codesList: [],
  emailsList: [],
  translationsList: [],
  multimediaList: [],
  rateType: ExtraRateType.EXTRA_RATE_TYPE_UNKNOWN,
  ratePrice: 0,
  type: ExtraType.EXTRA_TYPE_ROOM,
  availability: ExtraUse.EXTRA_USE_UNKNOWN,
  applyTo: ExtraApplyTo.EXTRA_APPLY_TO_ALL_STAY_DAYS_EXCEPT_CHECKOUT,
  applyToGuests: [],
  lockType: ExtraLockType.EXTRA_LOCK_TYPE_STAY,
  blockage: ExtraUse.EXTRA_USE_UNKNOWN,
  travelWindow: defaultRangeDateWindow,
  minStayType: ExtraRestrictionUse.EXTRA_RESTRICTION_USE_UNKNOWN,
  maxStayType: ExtraRestrictionUse.EXTRA_RESTRICTION_USE_UNKNOWN,
  minNoticeType: ExtraRestrictionUse.EXTRA_RESTRICTION_USE_UNKNOWN,
  maxNoticeType: ExtraRestrictionUse.EXTRA_RESTRICTION_USE_UNKNOWN,
  maxUnits: "1",
  minStay: undefined,
  maxStay: undefined,
  minNotice: undefined,
  maxNotice: undefined,
  tax: false,
  ...defaultExtraCategoryFormFields(),
};

export const applyToGuestOptions = [
  {
    name: GuestType.ADULT,
    ticker: GuestType.ADULT,
    translations: {
      en: {
        name: "ADULT",
      },
      es: {
        name: "ADULTO",
      },
    },
  },
  {
    name: GuestType.CHILD,
    ticker: GuestType.CHILD,
    translations: {
      en: {
        name: "CHILD",
      },
      es: {
        name: "NIÑO",
      },
    },
  },
  {
    name: GuestType.BABY,
    ticker: GuestType.BABY,
    translations: {
      en: {
        name: "BABY",
      },
      es: {
        name: "BEBÉ",
      },
    },
  },
  {
    name: GuestType.TEENAGER,
    ticker: GuestType.TEENAGER,
    translations: {
      en: {
        name: "JUNIOR",
      },
      es: {
        name: "JUNIOR",
      },
    },
  },
  {
    name: GuestType.SENIOR,
    ticker: GuestType.SENIOR,
    translations: {
      en: {
        name: "SENIOR",
      },
      es: {
        name: "SENIOR",
      },
    },
  },
];
